<template>
  <v-alert
    v-if="isImpersonating"
    dense
    tile
    type="warning"
    color="primary"
    class="ma-0 text_google d-flex align-center justify-center"
  >
    <span class="mr-3">
      กำลังเข้าใช้งานแทนบัญชี: <b>{{ targetDisplayName }}</b>
      (การกระทำถูกบันทึกลงประวัติการสวมสิทธิ์)
    </span>
    <v-btn small color="white" outlined @click="endImpersonation">
      <v-icon left small>mdi-logout-variant</v-icon>กลับสู่บัญชีผู้ดูแลระบบ
    </v-btn>
  </v-alert>
</template>

<script>
import { impersonationMixin } from "@/mixins/impersonation";

export default {
  name: "ImpersonationBanner",
  mixins: [impersonationMixin],
  data() {
    return {
      isImpersonating: false,
      targetDisplayName: "",
    };
  },
  created() {
    try {
      const backup = localStorage.getItem("impersonation_admin_backup");
      if (!backup) return;
      this.isImpersonating = true;
      const target = JSON.parse(localStorage.getItem("user"));
      this.targetDisplayName =
        (target &&
          (target.user_name ||
            [target.frist_name, target.last_name].filter(Boolean).join(" ") ||
            [target.personnel_etc_fristname, target.personnel_etc_lastname]
              .filter(Boolean)
              .join(" ") ||
            target.NameFL)) ||
        "-";
    } catch (e) {
      this.isImpersonating = false;
    }
  },
};
</script>
